import React from 'react'
import { Link } from 'react-router-dom'
import { BarChart3, Target, Shield } from 'lucide-react'

/**
 * Home page component - landing page for the application
 * Mobile-first design with responsive layout
 */
const HomePage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-purple-700 text-white py-16 md:py-24">
        <div className="container mx-auto text-center px-4">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Welcome to Startup TNT Angel Vault
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-blue-100 max-w-3xl mx-auto">
            Your comprehensive platform for angel investing and portfolio management. 
            Review your investment portfolio and discover innovative startups.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/dashboard"
              className="bg-white text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Get Started
            </Link>
            <Link
              to="https://startuptnt.com/contact"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900">
            What is Angel Vault?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="mb-4">
                <BarChart3 className="w-12 h-12 text-blue-600 mx-auto" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900">Portfolio Management</h3>
              <p className="text-gray-600">
                Track your investments, monitor updates, and manage your portfolio all in one place.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="mb-4">
                <Target className="w-12 h-12 text-green-600 mx-auto" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900">Deal Discovery</h3>
              <p className="text-gray-600">
                Discover promising startups and follow-on opportunities.
              </p>
            </div>
            <div className="text-center p-6">
              <div className="mb-4">
                <Shield className="w-12 h-12 text-purple-600 mx-auto" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-gray-900">Secure Platform</h3>
              <p className="text-gray-600">
                Top-notch security to protect your investments and personal information.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto text-center px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900">
            The Startup
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            The Startup TNT Angel Vault is currently in closed beta and is only open to select Startup TNT angel investors. 
          </p>
          <Link
            to="https://startuptnt.com/contact"
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-block"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  )
}

export default HomePage
